module.exports = __webpack_public_path__ + "static/adebayo-b5e7c922d5dddbde644793d92404eeda.png";